import React, { PureComponent } from 'react';
import injectSheet from 'react-jss'
import cn from 'classnames'

import flow from 'lodash/flow'

class BackgroundContrastContainer extends PureComponent {
    render() {
      const { classes, className, applyContrast, children, dataCy } = this.props;
      return (
        <section className={cn(className, applyContrast && classes.contrast )} data-cy={dataCy}>
          {children}
        </section>
      )
    }
}
export default flow([
    injectSheet((theme) => ({
      contrast: {
        backgroundColor: theme.colors.info,
        paddingTop: theme.spacing.normal,
        paddingBottom: theme.spacing.normal,
        [theme.breakpoint('tablet')]: {
            paddingTop: theme.spacing.large,
            paddingBottom: theme.spacing.large,
        },
        '& > *:last-child': {
          marginBottom: 0
        }
      }
  })
)])( BackgroundContrastContainer );



// WEBPACK FOOTER //
// ./src/components/LandingPage/BackgroundContrastContainer.js